<script lang="ts">
    
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import { authorizationService, meService } from "../Services";

    export let allow: number[] = undefined;

    const navigate = useNavigate();
    let isAuthorized = true;

    onMount(async () => {

        if (!allow) {
            navigate('/login');
            return;
        }

        const me = await meService.getMePromise();

        if (!allow.includes(me.typeId.value)) {
            authorizationService.clearToken();
            navigate('/login');
            return;
        }

        isAuthorized = true;

    });

</script>

{#if isAuthorized}
    <slot />
{/if}
